const USDateFormatRegex = /(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)(\d{2})/; // mm/dd/yyyy

function getFormattedDate(date: Date) {
  return date.toISOString().slice(0, 10);
}

function hasValidDateRange(startDate: string, endDate: string) {
  const startTimestamp = Date.parse(startDate);
  const endTimestamp = Date.parse(endDate);

  const todayDate = getFormattedDate(new Date());
  const todayTimestamp = Date.parse(todayDate);

  return startTimestamp >= todayTimestamp && startTimestamp < endTimestamp;
}

function isValidDateFormat(dateString: string) {
  return dateString.match(USDateFormatRegex);
}

export { getFormattedDate, hasValidDateRange, isValidDateFormat };
